document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-asos-gallery]').forEach(function (gallery) {
    const thumbsWrap = gallery.querySelector('[data-thumbs]')?.closest('.asos-gallery__thumbs-wrap');
    const thumbsContainer = gallery.querySelector('[data-thumbs]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-thumb]'));
    const slides = Array.from(gallery.querySelectorAll('[data-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const stagePrev = gallery.querySelector('[data-stage-prev]');
    const stageNext = gallery.querySelector('[data-stage-next]');
    const thumbPrev = gallery.querySelector('[data-thumb-prev]');
    const thumbNext = gallery.querySelector('[data-thumb-next]');

    if (!thumbs.length || !slides.length) return;

    let currentIndex = 0;

    function showSlide(index) {
      currentIndex = index;

      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
      });

      thumbs.forEach(function (thumb, thumbIndex) {
        const active = thumbIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');

        if (active && thumb.offsetParent !== null) {
          thumb.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      });

      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });

      updateStageArrows();
      updateThumbArrows();
    }

    function updateStageArrows() {
      if (stagePrev) stagePrev.disabled = currentIndex === 0;
      if (stageNext) stageNext.disabled = currentIndex === slides.length - 1;
    }

    function updateThumbArrows() {
      if (!thumbsContainer || !thumbPrev || !thumbNext || !thumbsWrap) return;

      const isDesktop = window.innerWidth > 989;
      const hasOverflow = isDesktop
        ? thumbsContainer.scrollHeight > thumbsContainer.clientHeight + 4
        : thumbsContainer.scrollWidth > thumbsContainer.clientWidth + 4;

      thumbsWrap.classList.toggle('is-static', !hasOverflow);

      if (!hasOverflow) {
        thumbPrev.disabled = true;
        thumbNext.disabled = true;
        return;
      }

      if (isDesktop) {
        thumbPrev.disabled = thumbsContainer.scrollTop <= 2;
        thumbNext.disabled = thumbsContainer.scrollTop + thumbsContainer.clientHeight >= thumbsContainer.scrollHeight - 2;
      } else {
        thumbPrev.disabled = thumbsContainer.scrollLeft <= 2;
        thumbNext.disabled = thumbsContainer.scrollLeft + thumbsContainer.clientWidth >= thumbsContainer.scrollWidth - 2;
      }
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        showSlide(index);
      });
    });

    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        showSlide(index);
      });
    });

    if (stagePrev) {
      stagePrev.addEventListener('click', function () {
        if (currentIndex > 0) showSlide(currentIndex - 1);
      });
    }

    if (stageNext) {
      stageNext.addEventListener('click', function () {
        if (currentIndex < slides.length - 1) showSlide(currentIndex + 1);
      });
    }

    if (thumbPrev && thumbsContainer) {
      thumbPrev.addEventListener('click', function () {
        const amount = window.innerWidth > 989 ? 260 : 220;
        if (window.innerWidth > 989) {
          thumbsContainer.scrollBy({ top: -amount, behavior: 'smooth' });
        } else {
          thumbsContainer.scrollBy({ left: -amount, behavior: 'smooth' });
        }
      });
    }

    if (thumbNext && thumbsContainer) {
      thumbNext.addEventListener('click', function () {
        const amount = window.innerWidth > 989 ? 260 : 220;
        if (window.innerWidth > 989) {
          thumbsContainer.scrollBy({ top: amount, behavior: 'smooth' });
        } else {
          thumbsContainer.scrollBy({ left: amount, behavior: 'smooth' });
        }
      });
    }

    if (thumbsContainer) {
      thumbsContainer.addEventListener('scroll', updateThumbArrows);
    }

    // V7 · mobile full-bleed com bolinhas: navegação principal por swipe + dots.
    const stage = gallery.querySelector('[data-stage]');
    if (stage) {
      let touchStartX = 0;
      let touchStartY = 0;

      stage.addEventListener('touchstart', function (event) {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      stage.addEventListener('touchend', function (event) {
        const touch = event.changedTouches && event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        if (deltaX < 0 && currentIndex < slides.length - 1) {
          showSlide(currentIndex + 1);
        } else if (deltaX > 0 && currentIndex > 0) {
          showSlide(currentIndex - 1);
        }
      }, { passive: true });
    }

    window.addEventListener('resize', updateThumbArrows);

    showSlide(0);
    updateThumbArrows();
  });
});

// A SÓS · BUYBOX + CTA fixo mobile · V10
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-asos-buybox]').forEach(function (buybox) {
    const mainButton = buybox.querySelector('[data-asos-add-to-cart]');
    const stickyBar = buybox.querySelector('[data-asos-mobile-sticky-atc]');
    const stickyButton = buybox.querySelector('[data-asos-mobile-sticky-button]');
    const stickyLabel = buybox.querySelector('[data-asos-mobile-sticky-label]');
    const productSection = buybox.closest('.asos-product');
    const isMagicRabbitPage = !!buybox.closest('.magic-rabbit-page');

    const qtyInput = buybox.querySelector('[data-asos-qty-input]');
    const qtyMinus = buybox.querySelector('[data-asos-qty-minus]');
    const qtyPlus = buybox.querySelector('[data-asos-qty-plus]');

    const freeShippingBadge = buybox.querySelector('[data-asos-product-free-shipping-badge]');
    const freeShippingMeter = buybox.querySelector('[data-asos-free-shipping]');
    const shippingMessage = buybox.querySelector('[data-asos-shipping-message]');
    const shippingProgress = buybox.querySelector('[data-asos-shipping-progress]');
    const shippingProgressBar = buybox.querySelector('[data-asos-shipping-progress-bar]');
    const optionSelects = Array.from(buybox.querySelectorAll('[data-asos-option]'));
    const variantsJson = buybox.querySelector('[data-asos-variants-json]');
    const skuRow = buybox.querySelector('[data-asos-sku]');
    const skuValue = buybox.querySelector('[data-asos-sku-value]');
    const variantInput = buybox.querySelector('[data-asos-variant-id]');
    const priceLabel = buybox.querySelector('[data-asos-price]');
    const compareLabel = buybox.querySelector('[data-asos-compare-price]');
    const installmentLabel = buybox.querySelector('[data-asos-installments]');
    const pixLabel = buybox.querySelector('[data-asos-pix-price]');

    let variants = [];
    if (variantsJson) {
      try {
        variants = JSON.parse(variantsJson.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    function formatMoneyBRL(cents) {
      try {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format((Number(cents) || 0) / 100);
      } catch (error) {
        return 'R$ ' + (((Number(cents) || 0) / 100).toFixed(2)).replace('.', ',');
      }
    }

    function resolveSelectedVariant() {
      if (!variants.length || !optionSelects.length) return null;
      const selectedOptions = optionSelects.map(function (select) { return select.value; });
      return variants.find(function (variant) {
        if (!Array.isArray(variant.options)) return false;
        return variant.options.every(function (value, index) {
          return String(value) === String(selectedOptions[index]);
        });
      }) || null;
    }

    function syncFreeShipping(priceCents) {
      const threshold = Number(buybox.dataset.freeShippingThresholdCents || 0);
      const cartTotal = Number(buybox.dataset.cartTotalCents || 0);
      const price = Number(priceCents || buybox.dataset.currentVariantPriceCents || 0);

      if (!threshold) return;

      const productQualifies = price >= threshold;
      if (freeShippingBadge) freeShippingBadge.hidden = !productQualifies;
      if (freeShippingMeter) freeShippingMeter.hidden = productQualifies;

      if (!freeShippingMeter || productQualifies) return;

      const projectedTotal = cartTotal + price;
      const remaining = Math.max(0, threshold - projectedTotal);
      const progress = Math.min(100, Math.max(0, (projectedTotal / threshold) * 100));

      if (shippingProgress) {
        shippingProgress.setAttribute('aria-valuenow', String(Math.round(progress)));
      }
      if (shippingProgressBar) {
        shippingProgressBar.style.width = progress + '%';
      }
      if (shippingMessage) {
        if (cartTotal >= threshold) {
          shippingMessage.textContent = 'Seu carrinho já tem frete grátis';
        } else if (remaining <= 0) {
          shippingMessage.textContent = 'Com este produto, você libera o frete grátis';
        } else {
          shippingMessage.innerHTML = 'Faltam <strong>' + formatMoneyBRL(remaining) + '</strong> para liberar';
        }
      }
    }

    function getInventoryLimit() {
      if (!qtyInput) return null;
      const raw = qtyInput.getAttribute('data-inventory-quantity');
      if (raw === null || raw === '') return null;
      const parsed = parseInt(raw, 10);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
    }

    function normalizeQuantity(value) {
      let next = parseInt(value, 10);
      if (!Number.isFinite(next) || next < 1) next = 1;
      const inventoryLimit = getInventoryLimit();
      if (inventoryLimit !== null) next = Math.min(next, inventoryLimit);
      return next;
    }

    function setQuantity(nextValue) {
      if (!qtyInput) return;
      const next = normalizeQuantity(nextValue);
      qtyInput.value = String(next);
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (qtyMinus) qtyMinus.disabled = next <= 1;
      const inventoryLimit = getInventoryLimit();
      if (qtyPlus) qtyPlus.disabled = inventoryLimit !== null && next >= inventoryLimit;
    }

    if (qtyInput) {
      if (qtyMinus) {
        qtyMinus.addEventListener('click', function () {
          setQuantity((parseInt(qtyInput.value, 10) || 1) - 1);
        });
      }
      if (qtyPlus) {
        qtyPlus.addEventListener('click', function () {
          setQuantity((parseInt(qtyInput.value, 10) || 1) + 1);
        });
      }
      qtyInput.addEventListener('change', function () { setQuantity(qtyInput.value); });
      qtyInput.addEventListener('blur', function () { setQuantity(qtyInput.value); });
      setQuantity(qtyInput.value);
    }

    const realStockNotice = buybox.querySelector('[data-asos-real-stock]');
    const realStockJson = buybox.querySelector('[data-asos-real-stock-json]');
    let realStockVariants = {};
    if (realStockJson) {
      try { realStockVariants = JSON.parse(realStockJson.textContent); } catch (error) { realStockVariants = {}; }
    }
    function syncRealStock(variant) {
      if (!realStockNotice) return;
      const stock = variant && realStockVariants[String(variant.id)];
      const quantity = stock ? Number(stock.quantity) : 0;
      const visible = !!(stock && stock.available && stock.tracked && stock.deny && quantity > 0 && quantity < 10);
      realStockNotice.hidden = !visible;
      realStockNotice.textContent = visible ? (quantity === 1 ? 'Só resta 1 unidade' : 'Só restam ' + quantity + ' unidades') : '';
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        window.setTimeout(function () {
          const selectedVariant = resolveSelectedVariant();
          syncRealStock(selectedVariant);
          if (variantInput) {
            const nextId = selectedVariant ? String(selectedVariant.id) : '';
            if (variantInput.value !== nextId) {
              variantInput.value = nextId;
              variantInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          if (mainButton) {
            const canNotify = !!(window.notify_me && window.notify_me.show);
            const isUnavailable = !selectedVariant || !selectedVariant.available;
            mainButton.disabled = isUnavailable && !canNotify;
            mainButton.type = isUnavailable ? 'button' : 'submit';
            mainButton.setAttribute('data-available', !isUnavailable ? 'true' : 'false');
            mainButton.setAttribute('data-asos-notify-mode', isUnavailable ? 'true' : 'false');
            mainButton.classList.toggle('is-notify-me', isUnavailable);
            mainButton.setAttribute('data-asos-notify-variant', selectedVariant ? String(selectedVariant.title || '') : '');
            const label = mainButton.querySelector('[data-asos-atc-label]');
            if (label) label.textContent = isUnavailable ? 'Me avise' : 'Comprar';
          }
          if (skuRow && skuValue) {
            const sku = selectedVariant ? String(selectedVariant.sku || '').trim() : '';
            skuValue.textContent = sku;
            skuRow.hidden = !sku;
          }
          if (selectedVariant && selectedVariant.price != null) {
            const price = Number(selectedVariant.price) || 0;
            buybox.dataset.currentVariantId = String(selectedVariant.id);
            buybox.dataset.currentVariantPriceCents = String(price);
            if (priceLabel) priceLabel.textContent = formatMoneyBRL(price);
            if (compareLabel) {
              const compare = Number(selectedVariant.compare_at_price) || 0;
              compareLabel.hidden = compare <= price;
              compareLabel.textContent = compare > price ? formatMoneyBRL(compare) : '';
            }
            if (installmentLabel) {
              let count = Math.max(1, Number(buybox.dataset.maxInstallments) || 6);
              const minimum = Number(buybox.dataset.installmentMinCents) || 0;
              if (buybox.dataset.installmentLimiter === 'true' && minimum > 0) {
                count = Math.max(1, Math.min(count, Math.ceil(price / minimum)));
              }
              installmentLabel.hidden = count <= 1;
              installmentLabel.innerHTML = 'ou ' + count + 'x de <strong>' + formatMoneyBRL(Math.round(price / count)) + '</strong>';
            }
            if (pixLabel && buybox.dataset.pixEnabled === 'true') {
              const discount = Number(buybox.dataset.pixDiscount) || 0;
              const pixPrice = price - Math.floor(price * discount / 100);
              pixLabel.querySelector('strong').textContent = formatMoneyBRL(pixPrice);
            }
            syncFreeShipping(price);
            if (qtyInput) {
              qtyInput.dataset.price = String(price);
              if (selectedVariant.inventory_management && selectedVariant.inventory_policy !== 'continue') {
                qtyInput.setAttribute('data-inventory-quantity', String(Math.max(0, Number(selectedVariant.inventory_quantity) || 0)));
              } else {
                qtyInput.removeAttribute('data-inventory-quantity');
              }
            }
          }
          if (qtyInput) setQuantity(1);
        }, 0);
      });
    });

    syncFreeShipping(Number(buybox.dataset.currentVariantPriceCents || 0));

    function openNotifyPopup() {
      if (!mainButton || mainButton.getAttribute('data-asos-notify-mode') !== 'true') return;
      const popup = document.querySelector('[data-notify-popup]');
      if (!popup) return;

      const title = mainButton.getAttribute('data-asos-notify-title') || buybox.dataset.productTitle || '';
      const link = mainButton.getAttribute('data-asos-notify-url') || window.location.href;
      const variant = mainButton.getAttribute('data-asos-notify-variant') || '';

      popup.querySelectorAll('.halo-notify-product-title').forEach(function (input) { input.value = title; });
      popup.querySelectorAll('.halo-notify-product-link').forEach(function (input) { input.value = link; });
      popup.querySelectorAll('.halo-notify-product-variant').forEach(function (input) { input.value = variant; });
      document.body.classList.add('notify-me-show');
    }

    if (mainButton) {
      mainButton.addEventListener('click', function (event) {
        if (mainButton.getAttribute('data-asos-notify-mode') !== 'true') return;
        event.preventDefault();
        event.stopPropagation();
        openNotifyPopup();
      });
    }

    if (!mainButton || !stickyBar || !stickyButton) return;

    function syncStickyState() {
      const notifyMode = mainButton.getAttribute('data-asos-notify-mode') === 'true';
      stickyButton.disabled = mainButton.disabled;
      stickyButton.setAttribute('aria-disabled', mainButton.disabled ? 'true' : 'false');
      stickyButton.classList.toggle('is-notify-mode', notifyMode);

      const mainLabel = mainButton.querySelector('[data-asos-atc-label]');
      const customLabel = stickyButton.getAttribute('data-asos-sticky-custom-label');

      if (stickyLabel && mainLabel) {
        stickyLabel.textContent = notifyMode
          ? mainLabel.textContent.trim()
          : (customLabel || mainLabel.textContent.trim());
      }
    }

    function getToolbarHeight() {
      const toolbar = document.querySelector('.halo-sticky-toolbar-mobile');
      if (!toolbar || window.getComputedStyle(toolbar).display === 'none') return 0;
      return Math.ceil(toolbar.getBoundingClientRect().height);
    }

    function updateStickyPosition() {
      stickyBar.style.setProperty('--asos-mobile-toolbar-height', getToolbarHeight() + 'px');
    }

    function updateStickyVisibility() {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      let shouldShow = isMobile;

      if (shouldShow && productSection) {
        const toolbarHeight = getToolbarHeight();
        const stickyHeight = Math.ceil(stickyBar.getBoundingClientRect().height || 70);
        const safeLine = window.innerHeight - toolbarHeight - stickyHeight - 8;

        if (isMagicRabbitPage) {
          const footer = document.querySelector('footer');
          shouldShow = !footer || footer.getBoundingClientRect().top > safeLine;
        } else {
          const rect = productSection.getBoundingClientRect();
          shouldShow = rect.bottom > safeLine && rect.top < window.innerHeight;
        }
      }

      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    stickyButton.addEventListener('click', function () {
      if (mainButton.disabled) return;
      mainButton.click();
    });

    const mainButtonObserver = new MutationObserver(function () {
      syncStickyState();
      updateStickyVisibility();
    });

    mainButtonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true
    });

    const toolbar = document.querySelector('.halo-sticky-toolbar-mobile');
    if (toolbar && 'ResizeObserver' in window) {
      const toolbarObserver = new ResizeObserver(function () {
        updateStickyPosition();
        updateStickyVisibility();
      });
      toolbarObserver.observe(toolbar);
    }

    let scrollTicking = false;
    window.addEventListener('scroll', function () {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        updateStickyVisibility();
        scrollTicking = false;
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateStickyPosition();
      updateStickyVisibility();
    });
    window.addEventListener('orientationchange', function () {
      updateStickyPosition();
      updateStickyVisibility();
    });

    window.addEventListener('load', function () {
      updateStickyPosition();
      updateStickyVisibility();
    }, { once: true });
    window.setTimeout(function () {
      updateStickyPosition();
      updateStickyVisibility();
    }, 400);
    window.setTimeout(function () {
      updateStickyPosition();
      updateStickyVisibility();
    }, 1200);

    syncStickyState();
    updateStickyPosition();
    updateStickyVisibility();
  });
});

// A SÓS · V11 · respiro visual entre múltiplos estímulos
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.asos-product__quick-highlights .asos-product__quick-highlight:first-child').forEach(function (item) {
    const text = (item.textContent || '').trim();
    if (!/[•+]/.test(text)) return;
    item.textContent = text.replace(/\s*[•+]\s*/g, '\u00A0\u00A0+\u00A0\u00A0');
  });

  document.querySelectorAll('.asos-product__essential-v5-row').forEach(function (row) {
    const label = row.querySelector('dt');
    const value = row.querySelector('dd');
    if (!label || !value) return;

    const labelText = (label.textContent || '').trim().toLowerCase();
    if (!labelText.includes('estímulo')) return;

    const text = (value.textContent || '').trim();
    if (!/[•+]/.test(text)) return;
    value.textContent = text.replace(/\s*[•+]\s*/g, '\u00A0\u00A0•\u00A0\u00A0');
  });
});


// A SÓS | Player dos vídeos do produto
// Os cartões só têm a capa; o vídeo carrega quando alguém abre o player.
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.asos-product__stories').forEach(function (root) {
    const player = root.querySelector('[data-story-player]');
    const cards = Array.from(root.querySelectorAll('[data-story-open]'));

    if (!player || !cards.length || typeof player.showModal !== 'function') return;

    const video = player.querySelector('[data-story-video]');
    const toggle = player.querySelector('[data-story-toggle]');
    const muteButton = player.querySelector('[data-story-mute]');
    const prevButton = player.querySelector('[data-story-prev]');
    const nextButton = player.querySelector('[data-story-next]');
    const counter = player.querySelector('[data-story-counter]');
    const bars = Array.from(player.querySelectorAll('[data-story-bar]'));

    let current = 0;
    let muted = false;
    let frame = null;
    let opener = null;

    function setProgress(index, value) {
      if (bars[index]) bars[index].style.setProperty('--progress', value);
    }

    function trackProgress() {
      if (video.duration) setProgress(current, Math.min(video.currentTime / video.duration, 1));
      frame = video.paused ? null : requestAnimationFrame(trackProgress);
    }

    function syncMute() {
      player.classList.toggle('is-muted', muted);
      muteButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
      muteButton.setAttribute('aria-label', muted ? 'Ativar o som' : 'Tirar o som');
    }

    function play() {
      video.muted = muted;

      const attempt = video.play();

      // Sem gesto do usuário o navegador só deixa tocar mudo.
      if (attempt) {
        attempt.catch(function () {
          if (video.muted) return;
          muted = true;
          syncMute();
          video.muted = true;
          video.play().catch(function () {});
        });
      }
    }

    function load(index) {
      current = index;

      video.pause();
      video.replaceChildren(
        cards[index].closest('.asos-product__story-card').querySelector('[data-story-sources]').content.cloneNode(true)
      );
      video.poster = cards[index].dataset.poster || '';
      video.load();

      bars.forEach(function (_, barIndex) {
        setProgress(barIndex, barIndex < index ? 1 : 0);
      });

      counter.textContent = index + 1 + ' / ' + cards.length;
      prevButton.disabled = index === 0;
      nextButton.disabled = index === cards.length - 1;

      play();
    }

    function go(step) {
      const target = current + step;

      if (target < 0) {
        video.currentTime = 0;
        play();
        return;
      }

      if (target >= cards.length) return;

      load(target);
    }

    function open(index) {
      opener = cards[index];
      document.documentElement.classList.add('asos-story-open');
      player.showModal();
      load(index);
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () {
        open(index);
      });
    });

    // Um toque nas bordas troca de vídeo (como nos stories); no meio, pausa.
    toggle.addEventListener('click', function (event) {
      if (event.detail > 0) {
        const box = toggle.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width;

        if (x < 0.28) return go(-1);
        if (x > 0.72) return go(1);
      }

      if (video.paused) play();
      else video.pause();
    });

    muteButton.addEventListener('click', function () {
      muted = !muted;
      video.muted = muted;
      syncMute();
    });

    prevButton.addEventListener('click', function () {
      go(-1);
    });

    nextButton.addEventListener('click', function () {
      go(1);
    });

    player.querySelector('[data-story-close]').addEventListener('click', function () {
      player.close();
    });

    // Clique fora do vídeo (no fundo escuro) fecha.
    player.addEventListener('click', function (event) {
      if (event.target === player) player.close();
    });

    player.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') go(-1);
      else if (event.key === 'ArrowRight') go(1);
      else if (event.key === 'm' || event.key === 'M') muteButton.click();
      else return;

      event.preventDefault();
    });

    video.addEventListener('play', function () {
      player.classList.remove('is-paused');
      toggle.setAttribute('aria-label', 'Pausar');
      if (!frame) frame = requestAnimationFrame(trackProgress);
    });

    video.addEventListener('pause', function () {
      player.classList.add('is-paused');
      toggle.setAttribute('aria-label', 'Tocar');
    });

    video.addEventListener('ended', function () {
      setProgress(current, 1);
      if (current < cards.length - 1) load(current + 1);
    });

    player.addEventListener('close', function () {
      if (frame) cancelAnimationFrame(frame);
      frame = null;

      // Para o download, não só a reprodução.
      video.pause();
      video.replaceChildren();
      video.removeAttribute('poster');
      video.load();

      document.documentElement.classList.remove('asos-story-open');
      if (opener) opener.focus();
    });

    syncMute();
  });
});
